/**
 * @file: Canteen.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 食堂公示管理
 */
import request from '@/utils/request'

/**
 * 查看食堂公示列表(APP业务管理)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function canteenAppListGet(data) {
  return request({
    type: 'biz',
    url: 'canteen/APP/list/get',
    method: 'post',
    data
  })
}

/**
 * 查看食堂公示列表(PC业务管理)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function canteenPcListGet(data) {
  return request({
    type: 'biz',
    url: 'canteen/PC/list/get',
    method: 'post',
    data
  })
}

/**
 * 添加食堂公示
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function canteenAdd(data) {
  return request({
    type: 'biz',
    url: 'canteen/add',
    method: 'post',
    data
  })
}

/**
 * 删除食堂公示
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function canteenDelete(data) {
  return request({
    type: 'biz',
    url: 'canteen/delete',
    method: 'post',
    data
  })
}

/**
 * 查看食堂公示详情
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function canteenGet(data) {
  return request({
    type: 'biz',
    url: 'canteen/get',
    method: 'post',
    data
  })
}

/**
 * 修改食堂公示
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function canteenUpdate(data) {
  return request({
    type: 'biz',
    url: 'canteen/update',
    method: 'post',
    data
  })
}

/**
 * 获取编辑的食堂公示信息
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function canteenUpdateGet(data) {
  return request({
    type: 'biz',
    url: 'canteen/update/get',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Canteen.js